<template>
  <div class="form-group">
    <label :for="compId">{{ $t(i18nLabel) }}</label>
    <input type="search" :id="compId" :value="modelValue || ''" @input="$emit('update:modelValue', $event.target.value)" class="form-control" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import _uniqueId from 'lodash.uniqueid'

export default defineComponent({
  name: 'ControlSearch',
  props: {
    i18nLabel: { type: String, required: true },
    modelValue: { type: String }
  },
  data() {
    return {
      compId: _uniqueId('control-search-')
    }
  }
});
</script>
